
document.addEventListener("DOMContentLoaded", function() {
        
    if ($("div").hasClass("text-shortener")) {

        const sections = document.querySelectorAll(".text-shortener");

        sections.forEach(section => {
            const p = section.querySelector("p");
            const btn = section.querySelector(".text-shortener-toggle");

            if (!p || !btn) return;

            const wordLimit = parseInt(section.dataset.limit, 10) || 200; // Standard = 200
            const fullHTML = p.innerHTML.trim();
            const fullText = p.textContent.trim();

            const words = fullText.split(/\s+/);

            if (words.length <= wordLimit) {
                btn.style.display = "none";
                return;
            }

            function truncateHTML(html, limit) {
                const div = document.createElement("div");
                div.innerHTML = html;

                let count = 0;
                let done = false;

                function processNode(node) {
                    if (done) return null;

                    if (node.nodeType === Node.TEXT_NODE) {
                        const nodeWords = node.textContent.split(/\s+/);
                        if (count + nodeWords.length > limit) {
                            const remaining = limit - count;
                            const truncatedText = nodeWords.slice(0, remaining).join(" ");
                            done = true;
                            return document.createTextNode(truncatedText);
                        } else {
                            count += nodeWords.length;
                            return document.createTextNode(node.textContent);
                        }
                    } else if (node.nodeType === Node.ELEMENT_NODE) {
                        const clone = node.cloneNode(false);
                        node.childNodes.forEach(child => {
                            const processed = processNode(child);
                            if (processed) clone.appendChild(processed);
                        });
                        return clone;
                    }
                    return null;
                }

                const fragment = document.createDocumentFragment();
                div.childNodes.forEach(node => {
                    const processed = processNode(node);
                    if (processed) fragment.appendChild(processed);
                });

                const tempDiv = document.createElement("div");
                tempDiv.appendChild(fragment);
                return tempDiv.innerHTML;
            }

            const shortHTML = truncateHTML(fullHTML, wordLimit) + "...";
            let collapsed = true;

            p.innerHTML = shortHTML;
            btn.style.display = "inline-block";
            btn.innerText = "Mehr anzeigen";

            btn.addEventListener("click", () => {
                if (collapsed) {
                    p.innerHTML = fullHTML;
                    btn.innerText = "Weniger anzeigen";
                } else {
                    p.innerHTML = shortHTML;
                    btn.innerText = "Mehr anzeigen";
                }
                collapsed = !collapsed;
            });
        });

    }

});